import MehDefault from '../../assets/icons/smiley-default-neutral.svg';
import MehInactive from '../../assets/icons/smiley-inactive-neutral.svg';
import MehSelected from '../../assets/icons/smiley-selected-neutral.svg';

interface Props {
  state?: 'default' | 'inactive' | 'selected';
  className?: string;
}

export const Meh = ({ state = 'default', className }: Props) => {
  return (
    <img
      src={state === 'default' ? MehDefault : state === 'inactive' ? MehInactive : MehSelected}
      alt="Smile"
      className={`${className || 'h-8 w-8'}`}
    />
  );
};
